import React from 'react';
import styled from '@emotion/styled';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { pxToRem } = StyleLibrary;

const Label = styled.label({
  color: 'var(--color-body)',
  display: 'inline-block',
  fontFamily: 'var(--font-heading)',
  fontSize: pxToRem(18),
  fontWeight: 'var(--font-weight-medium)' as any,
  lineHeight: pxToRem(24),
  marginBottom: pxToRem(24),
  width: 'fit-content',

  // Reduce gap for notes section below.
  '& + .notes': {
    marginTop: pxToRem(-16),
  },

  // Reduce gap for error message below.
  '& + .error': {
    marginTop: pxToRem(-16),
  },
});

type Props = {
  htmlFor: string;
  label: string;
};

export const LabelElement: React.FC<Props> = ({ htmlFor, label }) => {
  return label && <Label htmlFor={htmlFor}>{label}</Label>;
};
